import type {
  ChartProps,
  IChartListDynamicVarData,
  TData,
  TDataCell,
} from "../types";

interface IProps {
  settings: ChartProps;
  data: IChartListDynamicVarData;
}

const escapeData = (data: Record<string, string>) => {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      typeof value === "string"
        ? value
            .replace(/"/g, '\\"')
            .replace(/[\r\n]+/g, " ")
            .replace(/\s+/g, " ")
            .trim()
        : value,
    ]),
  );
};

const replaceInString = (str: string, data: Record<string, string>): string => {
  return Object.entries(data).reduce(
    (s, [key, value]) => s.replace(new RegExp(`\\[${key}\\]`, "g"), value),
    str,
  );
};

const replacePlaceholders = (
  cell: TDataCell,
  data: Record<string, string>,
): TDataCell => {
  if (!cell) return cell;
  const newCell = { ...cell };
  for (const field of Object.keys(newCell)) {
    if (typeof newCell[field] === "string") {
      newCell[field] = replaceInString(newCell[field], data);
    }
  }
  return newCell;
};

export const parseChartListDynamicVar = ({
  settings,
  data,
}: IProps): ChartProps => {
  if (!data || data.data.length === 0) {
    return settings;
  }

  const originalData: TData = settings.data;
  if (!originalData || originalData.length < 2) {
    return settings;
  }

  const headerRow = originalData[0];
  const templateRow = originalData[1];

  const newData: TData = [headerRow];

  for (const item of data.data) {
    const replaceData = escapeData(item);
    const newRow = templateRow.map((cell) =>
      replacePlaceholders(cell, replaceData),
    );
    newData.push(newRow);
  }

  return {
    ...settings,
    data: newData,
  };
};
